import { useParams } from "react-router-dom";
import { db } from "../firebase";
import { createContext, useReducer, useEffect } from "react";
export const ApisValue = createContext(null);
export const ApisDisbatch = createContext(null);
const reducer = (state, action) => {
  const newState = { ...state };
  if (action.type === "set") {
    return action.value;
  }

  return newState;
};

export default function ApisContext({ children }) {
  const [state, dispatch] = useReducer(reducer, []);
  const { appId, pageId } = useParams();

  useEffect(() => {
    if (appId && pageId) {
      db.collection("apps")
        .doc(appId)
        .collection("apis")
        .orderBy("name")
        .onSnapshot((snap) => {
          const _apis = snap.docs.map((doc) => {
            return { ...doc.data(), id: doc.id };
          });
          dispatch({ type: "set", value: _apis });
        });
    }
  }, [appId, pageId]);

  return (
    <ApisValue.Provider value={state}>
      <ApisDisbatch.Provider value={dispatch}>{children}</ApisDisbatch.Provider>
    </ApisValue.Provider>
  );
}
